import React, { Suspense } from "react";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";

import { Switch } from "react-router-dom";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { Permissions } from "../../../util/Permissions";
import { UserGroupMenu } from "../../Common/layout/aside/aside-menu-lists/UserGroupMenu";
import { Section } from "../../Common/layout/Section";
import { Campaigns } from "./Campaign";


const CampaignManagementPages = () => {
    return <>
        <AsideMenu>
            <UserGroupMenu destination="/campaigns" />
        </AsideMenu>
        <Section>
            <Suspense fallback={<LayoutSplashScreen />}>
                <Switch>
                    <ContentRoute path="/campaigns/:userGroup" permission={Permissions.CAMPAIGNS} component={Campaigns} />
                </Switch>
            </Suspense>
        </Section>
    </>
};

export default CampaignManagementPages;
